import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "tags",
    object: "tag",
    header: [
      { text: "Label", value: "text" },
      { text: "Acciones", value: "actions", sortable: false }
    ],
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
